<template>
  <div class="login-body">
    <Toast />
    <div class="login-panel"></div>

    <div class="login-content" :style="($vssWidth > 767 && $vssWidth < 1800 ? 'width: 47%' : '')">
      <img src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB" style="margin-bottom: 2em" />

      <h1><span>{{ $t('login.title1') }}</span>{{ $t('login.title2') }}</h1>
      <p>{{ $t('login.subtitle') }}</p>

      <div class="login-input-wrapper">
        <InputText :placeholder="$t('login.username')" v-model="username" @keyup="refreshUsername++"
                   @keyup.enter="login" ref="username" />
      </div>

      <div class="login-input-wrapper">
        <Password toggleMask :placeholder="$t('login.password')" v-model="password" @keyup.enter="login"
                  style="width: 100%" />
      </div>

      <Button :disabled="loading" :label="$t('login.signin')" icon="pi pi-check" @click="login" ref="login" />
      <ProgressSpinner v-if="loading" style="height: 2em;margin: 0 0 0 -2em;padding-top: 0.5em" />
      <div class="login-input-wrapper">
        <Accordion class="changeresetbox">
          <AccordionTab :disabled="loading" :header="$t('login.resetpassword')">
            <div class="grid">
              <div class="col-12">
                <Button :disabled="loading" :label="$t('common.buttons.reset-password')" icon="fa fa-envelope-o"
                        @click="resetPassword" />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from '../service/LoginService';
import jwt_decode from 'jwt-decode';
import { VueScreenSizeMixin } from 'vue-screen-size';

export default {
  mixins: [ VueScreenSizeMixin ],
  created() {
    this.loginService = new LoginService();
  },
  beforeMount() {
    this.$store.dispatch('resetLoading');
  },
  mounted() {
    this.$store.commit('setUser', null);
    this.$store.commit('setSelectedPortfolio', null);
    this.$refs.login?.$el.focus();
  },
  data() {
    return {
      username: null,
      password: null,
      loginExecuted: false,
      refreshUsername: 0,
    };
  },
  computed: {
    user() {
      return { username: this.username, password: this.password };
    },
    loading() {
      return this.$store.state.loading > 0;
    },
  },
  methods: {
    login(user) {
      if (user != null && user.username != null && user.password != null) {
        this.username = user.username;
        this.password = user.password;
      }
      this.$store.dispatch('startLoading');
      this.loginService.doLogin(this.username, this.password).then(data => {
        this.$store.dispatch('stopLoading');
        if (data != null && data.message == null) {
          let roles = jwt_decode(data.jwt).groups.filter(role => role.includes('selectio')).map(role => role.split(':')[1]);
          let user = { username: this.username, token: data.jwt, refresh: data.refresh, role: '', roles: roles };
          this.$store.commit('setUser', user);
          this.$store.dispatch('startLoading');
          this.loginService.getUserData().then(userData => {
            this.$store.dispatch('stopLoading');
            user = this.loginService.mapUserDataToUser(userData, user);
            this.$store.dispatch('login', { vm: { vm: this }, user: user });
            let count = 0;
            if (user.selectioEnabled === true) count++;
            if (user.cofastEnabled === true) count++;
            if (user.lensEnabled === true) count++;
            if (user.databrainEnabled === true) count++;
            if (count > 1) {
              this.$router.push('/landing-page');
            } else if (count === 1 && user.selectioEnabled === true) {
              this.$endpoints.goToSelectio(user, this.$router, this.$store, this);
            } else if (count === 1 && user.cofastEnabled === true) {
              this.$endpoints.goToCofast();
            } else if (count === 1 && user.lensEnabled === true) {
              this.$endpoints.goToLens();
            } else if (count === 1 && user.databrainEnabled === true) {
              this.$endpoints.goToNettuno();
            } else {
              this.$toast.add({
                severity: this.$t('common.toasts.loginError.severity'),
                summary: this.$t('common.toasts.loginError.summary'),
                detail: this.$t('common.toasts.loginError.detail'),
                life: 60000,
              });
            }
          }).catch(e => {
            this.$toast.add({
              severity: this.$t('common.toasts.loginError.severity'),
              summary: this.$t('common.toasts.loginError.summary'),
              detail: this.$t('common.toasts.loginError.detail'),
              life: 60000,
            });
            this.$store.dispatch('resetLoading');
            throw e;
          });
        } else if (data != null) {
          this.$toast.add({
            severity: this.$t('common.toasts.loginError.severity'),
            summary: this.$t('common.toasts.loginError.summary'),
            detail: this.$t('common.toasts.loginError.detail'),
            life: 60000,
          });
        }
      }).catch(e => {
        this.$store.dispatch('resetLoading');
        this.$toast.add({
          severity: this.$t('common.toasts.loginError.severity'),
          summary: this.$t('common.toasts.loginError.summary'),
          detail: this.$t('common.toasts.loginError.detail'),
          life: 60000,
        });
        console.log('error authenticating', e);
      });
    },
    resetPassword() {
      const user = { username: this.username, password: this.password, application: 'selectio' };
      if (user.username == null || user.username === '') {
        this.$toast.add({
          severity: 'warn',
          summary: this.$t('common.toasts.resetPasswordNullField.summary'),
          detail: this.$t('common.toasts.resetPasswordNullField.detail'),
          life: 60000,
        });
      } else {
        this.loginService.resetPassword(user).then(() => {
          user.password = null;
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.toasts.resetPasswordSuccess.summary'),
            detail: this.$t('common.toasts.resetPasswordSuccess.detail'),
            life: 60000,
          });
        }).catch(e => {
          this.$toast.add({
            severity: 'error',
            summary: this.$t('common.toasts.resetPasswordError.summary'),
            detail: this.$t('common.toasts.resetPasswordError.detail'),
            life: 60000,
          });
          console.log('error resetPassword', e);
        });
      }
    },
    userData(data) {
      this.$store.dispatch('startLoading');
      this.$store.dispatch('login', { token: data.jwt, refresh: data.refresh });
      this.loginService.getUserData().then(d => {
        this.$store.dispatch('stopLoading');

        const user = {
          username: d.username,
          token: data.jwt,
          refresh: data.refresh,
          role: d.role,
          customerCode: d.customerCode,
          agencyCode: d.agencyCode,
          portfolioList: d.portfolioList,
        };
        if (user.role != null) {
          this.$store.dispatch('login', user);
          this.$router.replace('/');
        } else {
          this.$toast.add({
            severity: this.$t('common.toasts.userNotAuthorised.severity'),
            summary: this.$t('common.toasts.userNotAuthorised.summary'),
            detail: this.$t('common.toasts.userNotAuthorised.detail'),
            life: 60000,
          });
        }

      }).catch(e => {
        console.log('userData', e);
        this.$store.dispatch('resetLoading');
      });
    },
  },
};
</script>

<style lang="scss">
.p-password, input {
  width: 100%;
}

.changeresetbox {
  .p-accordion-header {
    background-color: inherit !important;

    .p-accordion-header-text {
      color: #43c3bf;
      font-weight: 400;
    }

    a {
      padding: 0.3em !important;
      padding-left: 0 !important;
      border: none !important;
      background-color: inherit !important;
    }

    .p-accordion-toggle-icon {
      display: none;
    }

    &:not(.p-highlight):not(.p-disabled):hover {
      color: inherit !important;

      a {
        background-color: inherit !important;
        border: none !important;
      }
    }

    &:not(.p-disabled).p-highlight {
      margin-bottom: 0;
      color: inherit !important;

      a {
        background-color: inherit !important;
        border: none !important;
      }

      &:hover {
        a {
          background-color: inherit !important;
          border: none !important;
        }
      }
    }
  }

  .p-accordion-content {
    background-color: inherit !important;
    border: none !important;
    padding: 0 !important;
    margin-top: 0.5em;
  }

  margin-top: -1em;
  padding-left: 0 !important;
}

</style>
